import React from "react";
import { useSelector } from "react-redux";
import { getWillPaysEmptyMessage } from "../../../store/selectors";
import EmptyCaseDialogMessage from "../EmptyCaseDialogMessage";

const NoWillPaysAvailable = () => {
  const { title, description } = useSelector(getWillPaysEmptyMessage);

  return (
    <EmptyCaseDialogMessage
      title={title}
      description={description}
      qaLabel="willPays-empty-state"
      iconName="info"
    />
  );
};

export default NoWillPaysAvailable;
